import { Component, OnInit, EventEmitter, Output, ViewChild } from '@angular/core';
import { Service, ServicesPTreeSelect } from 'src/app/shared/models/iCourrier/service';
import { TreeNode } from 'primeng/api';
import { Mail } from 'src/app/shared/models/mails/mail';
import * as _ from 'underscore';
import { ParamsService } from 'src/app/shared/services/params.service';
import { TreeSelect } from 'primeng/treeselect';
import { TranslateService } from '@devinforius/i-essentials';
import { ToastrService } from 'ngx-toastr';
import { ServicesService } from 'src/app/shared/services/services.service';
import { BinderClassificationDtoV2, DropdownService } from 'src/app/shared/interfaces';
import { ClassificationsService } from 'src/app/shared/services/classifications.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ClassificationInfos } from 'src/app/shared/models/classement/classement';
import { MeService } from 'src/app/shared/services/me.service';
import { FolderClassificationDetailsChildren } from 'src/app/shared/models/classement/chemise';
import { FolderClassificationDetails } from 'src/app/shared/models/classement/classeur';
import { manageServicesSetAsTreeSelect, manageServicesToBeMerged } from 'src/app/shared/utils/manage-services-for-tree-select.utils';
import { setServiceDescription } from 'src/app/utils/set-service-description.utils';
import { UserInfo } from 'src/app/shared/models';
@Component({
  selector: 'app-home-courrier-tree',
  templateUrl: './home-courrier-tree.component.html',
  styleUrls: ['./home-courrier-tree.component.scss'],
})
export class HomeCourrierTreeComponent implements OnInit {
  @ViewChild('treeSelect') treeSelect: TreeSelect;

  public myServices: Service[];
  public selectedServiceLV: number[] = [];
  public classements: TreeNode[] = [];
  public selectedNode: {
    classeurId: number;
    data: number;
  };
  public selectedClasseur: TreeNode;
  public selectedChemise: TreeNode;
  public mails: Mail[] = [];
  @Output() public searchParams = new EventEmitter<{ classeurId?: number; chemiseId?: number }>();
  public userID: number;

  public currentClasseurId: number = 0;
  public currentChemiseId: number = 0;
  public currentClassementId: number = 0;
  public selectedClassement: FolderClassificationDetails | FolderClassificationDetailsChildren;
  public optionsArchived: { label: string; value: string }[] = [];
  public ClasseurArchived: 'Exclude' | 'Include' | 'OnlyArchived' = 'Exclude';
  public ChemiseArchived: 'Exclude' | 'Include' | 'OnlyArchived' = 'Exclude';
  public ICourrierDisplayClassementId: string = null;

  public serviceParent: ServicesPTreeSelect[] = [];
  public mergedServices: {
    label: string;
    value: number | string;
    id: number;
    parentId: number;
    name: string;
    key: string;
    selectable: boolean;
    children: [];
  }[] = [];
  public translationPlaceholderPTree = null;

  constructor(
    public params: ParamsService,
    public translater: TranslateService,
    private toastr: ToastrService,
    private servicesService: ServicesService,
    private classificationsService: ClassificationsService,
    private meService: MeService
  ) {}

  ngOnInit(): void {
    this.optionsArchived = [
      { label: this.translater.translate('homeCourrier.inventory.include'), value: 'Include' },
      { label: this.translater.translate('homeCourrier.inventory.exclude'), value: 'Exclude' },
      { label: this.translater.translate('homeCourrier.inventory.onlyArchived'), value: 'OnlyArchived' },
    ];
    this.translationPlaceholderPTree = this.translater.translate('pleaseSelectOneOrMultipleServices');
    this.getUsersParametersForClassementId();
  }

  getUsersParametersForClassementId(): void {
    this.meService.getMyPersonalParams('CourrierCustomViews').subscribe({
      next: (personalParams) => {
        const index = personalParams.map((customView) => customView.name).indexOf('ICourrierDisplayClassementId');
        if (index > -1) {
          this.ICourrierDisplayClassementId = personalParams[index].value;
        }
        this.getUserInfosAndServices();
      },
      error: () => {
        this.toastr.error(this.translater.translate('error.errorOccurredWhileFetchingPersonalParams'));
      },
    });
  }

  getUserInfosAndServices(): void {
    this.meService.getUserInfo().subscribe({
      next: (userInfos) => {
        this.userID = userInfos.id;
        this.getAllServices(userInfos);
      },
      error: () => {
        this.toastr.error(this.translater.translate('error.errorOccurredWhileFetchingUserInfos'));
      },
    });
  }

  public getAllServices(userInfos: UserInfo): void {
    this.servicesService.fetchMappedServicesToPrimeNGDropdowns().subscribe({
      next: (services: DropdownService[]) => {
        if (userInfos.fullView) {
          this.manageServiceDisplay(services);
        } else {
          this.getMyServices(services);
        }
      },
      error: () => {
        this.toastr.error(this.translater.translate('error.errorOccurredWhileFetchingServices'));
      },
    });
  }
  public getMyServices(services: DropdownService[]): void {
    this.meService.getMeServicesExploses().subscribe({
      next: (servicesExplosed) => {
        const existingServices = services.filter((service) => servicesExplosed.some((explosedService) => explosedService.serviceId === service.id));
        this.manageServiceDisplay(existingServices);
      },
      error: () => {
        this.toastr.error(this.translater.translate('error.errorOccurredWhileFetchingServices'));
      },
    });
  }

  private manageServiceDisplay(response): void {
    const datasForService = manageServicesSetAsTreeSelect(response, this.translater);

    this.serviceParent = datasForService.servicesForSingleCheck;
    this.mergedServices = manageServicesToBeMerged(response);

    if (this.serviceParent.length === 1) {
      this.selectedServiceLV = [+this.serviceParent[0].value];
      this.onServiceSelect(this.selectedServiceLV);
    } else {
      this.serviceParent.unshift({
        label: this.translater.translate('homeCourrier.inventory.selectAll/unselectAll'),
        name: '',
        key: 'inforiusCheckAllForServices',
        value: 'inforiusCheckAllForServices',
        selectable: true,
        children: [],
      });

      const classement = JSON.parse(localStorage.getItem('classement'));
      if (classement) {
        this.selectedNode = classement;
        this.onServiceSelect(classement.serviceId);
        this.onClassementSelect(classement);
        localStorage.removeItem('classement');
      }
    }
  }

  public onServiceSelect(selectedService: number[]): void {
    this.getClassement(selectedService);
  }

  getClassement(arrayServiceID: number[]): void {
    this.classements = [];

    if (arrayServiceID.length > 0) {
      this.classificationsService
        .fetchFoldersClassificationV2({
          SvcIds: arrayServiceID,
          ClasseurArchived: this.ClasseurArchived,
          ChemiseArchived: this.ChemiseArchived,
        })
        .subscribe({
          next: (res: BinderClassificationDtoV2[]) => {
            const tempTreeArray = [];
            const ClassementArray = [];

            // Les parents sont ici donc, les classements de 1er niveau
            if (res?.length > 0) {
              res.map((item) => {
                const classification = new ClassificationInfos(item);
                if (classification.classeurs?.length > 0) {
                  classification.classeurs.map((classeur) => {
                    classeur.label =
                      (this.ICourrierDisplayClassementId === '1' ? '(' + classeur.id + ') ' : '') +
                      classification.code +
                      (' / ' + classeur.description);
                    classeur.labelOrder = classification.code.toLowerCase() + (' / ' + classeur.description);
                    classeur.data = classeur.id;
                    classeur.type = 'classeur';
                    classeur.children = classeur.children ? classeur.children : [];
                    classeur.actif = classification.actif;
                    classeur.key = classeur.id;
                    if (classeur.chemises?.length > 0) {
                      classeur.chemises.map((chemise) => {
                        classeur.children.push({
                          label: chemise.description,
                          labelLowercase: chemise.description.toLowerCase(),
                          data: chemise.id,
                          classementId: classification.id,
                          classeurId: classeur.id,
                          archived: chemise.archived ? chemise.archived : false,
                          type: 'chemise',
                          remarques: chemise.remarques,
                          accesRestreint: chemise.accesRestreint,
                          classementAffine: chemise.classementAffine,
                          localisation: chemise.localisation,
                          key: chemise.id,
                        });
                      });
                      const sortedChildren = _.chain(classeur.children).sortBy('labelLowercase').sortBy('archived').value();
                      classeur.children = sortedChildren;
                    }
                    if (this.selectedNode) {
                      if (this.selectedNode.classeurId) {
                        //Si on rentre ici c'est que dans la gestion des classements on a choisi de visualiser une chemise. Visualiser une chemise va faire que dans selectedNode on aura un classeurId et un data
                        if (classeur.id === this.selectedNode.classeurId) {
                          // on est dans le bon classeur, on va récupérer la bonne chemise
                          classeur.expanded = true; //Il FAUT expand à la main
                          classeur.children.map((child) => {
                            if (child.data === this.selectedNode.data) {
                              //on va alors récupérer la bonne chemise et ici on a pas encore le lien enfant/parent => on va devoir ajouter la propriété "parent" à selectedClassement afin que la donnée soit exactement la même que celle du p-tree
                              this.selectedClassement = child;
                              this.selectedClassement.parent = classeur;
                            }
                          });
                        }
                      } else {
                        //Si on a pas de classeurID c'est qu'on a choisi de visualiser un classeur => on a que this.selectedNode.data.
                        //On va donc check si le classeur actuel est celui que l'on veut
                        if (classeur.id === this.selectedNode.data) {
                          this.selectedClassement = classeur;
                        }
                      }
                    }
                    tempTreeArray.push(classeur);
                  });
                }
                ClassementArray.push(classification);
                classification.value = classification;
              });
            }
            this.classements = _.sortBy(tempTreeArray, 'labelOrder');
            this.patchServicesNumberOnLoopInTreeSelect(arrayServiceID);
          },
          error: (error: HttpErrorResponse) => {
            console.error('Error : ', error);
          },
        });
    }
  }

  patchServicesNumberOnLoopInTreeSelect(servicesIds): Promise<boolean> {
    return new Promise((resolve) => {
      const allServicesToBeAdded = [];
      servicesIds.map((serviceId) => {
        //pour chaque serviceId
        this.serviceParent.map((parent) => {
          //si le parentId correspond on push
          if (parent.id === serviceId) {
            allServicesToBeAdded.push(parent);
          } else {
            //Si pas on va devoir entrer dans les enfants
            if (parent.children && parent.children.length > 0) {
              recursive(serviceId, parent.children, allServicesToBeAdded);
            }
          }
        });
      });
      setTimeout(() => {
        this.treeSelect.value = allServicesToBeAdded;
        this.setPlaceholderServiceTreeSelect();
        resolve(true);
      }, 500);

      function recursive(serviceId, children, allServicesToBeAdded) {
        children.map((child) => {
          if (child.id === serviceId) {
            allServicesToBeAdded.push(child);
          } else {
            if (child.children && child.children.length > 0) {
              recursive(serviceId, child.children, allServicesToBeAdded);
            }
          }
        });
      }
    });
  }

  public onClassementSelect(value): void {
    this.selectedClassement = value;
    let data: { classeurId?: number; chemiseId?: number } = {};
    switch (value.type) {
      case 'classeur':
        data = {
          classeurId: +value.data,
        };
        this.searchParams.emit(data);
        break;
      case 'chemise':
        data = {
          chemiseId: +value.data,
        };
        this.searchParams.emit(data);
        break;
    }
  }

  select(): void {
    if (this.treeSelect.value.find((treeValue) => treeValue.key === 'inforiusCheckAllForServices')) {
      this.treeSelect.value = this.mergedServices.concat({
        label: '',
        value: 'inforiusCheckAllForServices',
        id: null,
        parentId: null,
        name: '',
        key: 'inforiusCheckAllForServices',
        selectable: true,
        children: [],
      });
      this.setPlaceholderServiceTreeSelect();
      this.selectedServiceLV = this.treeSelect.value.filter((option) => option.key !== 'inforiusCheckAllForServices').map((option) => +option.value);
      this.onServiceSelect(this.selectedServiceLV);
    } else {
      if (this.treeSelect.value.length === this.mergedServices.length) {
        this.treeSelect.value = this.treeSelect.value.concat({
          label: '',
          name: '',
          key: 'inforiusCheckAllForServices',
          value: 'inforiusCheckAllForServices',
          selectable: true,
          children: [],
        });
      }
      this.setPlaceholderServiceTreeSelect();
      this.selectedServiceLV = this.treeSelect.value.filter((option) => option.key !== 'inforiusCheckAllForServices').map((option) => +option.value);
      this.onServiceSelect(this.selectedServiceLV);
    }
  }

  unselect(event): void {
    if (event.node.key === 'inforiusCheckAllForServices') {
      this.treeSelect.value = [];
      this.setPlaceholderServiceTreeSelect();
      this.selectedServiceLV = [];
      this.classements = [];
    } else {
      const indexCheckAll = this.treeSelect.value.map((treeValue) => treeValue.key).indexOf('inforiusCheckAllForServices');
      if (indexCheckAll > -1) {
        this.treeSelect.value.splice(indexCheckAll, 1);
      }
      this.setPlaceholderServiceTreeSelect();
    }
  }

  setPlaceholderServiceTreeSelect(): void {
    let amountOfSelectedServices = '';
    if (this.treeSelect.value.length === 0) {
      amountOfSelectedServices = this.translationPlaceholderPTree;
    } else if (this.treeSelect.value.length === 1) {
      amountOfSelectedServices = this.treeSelect.value[0].label;
    } else {
      const totalOfSelectedServices = this.treeSelect.value.filter((x) => x.key !== 'inforiusCheckAllForServices').length;
      if (totalOfSelectedServices === this.mergedServices.length) {
        amountOfSelectedServices = this.translater.translate('allServicesChecked', {
          value: totalOfSelectedServices,
        });
      } else {
        amountOfSelectedServices = this.translater.translate('xServicesChecked', {
          value: totalOfSelectedServices,
        });
      }
    }
    const labelTreeHtml = document.getElementsByClassName('p-treeselect-label');
    labelTreeHtml[0].innerHTML = amountOfSelectedServices;
  }
}
